<template>
  <div v-loading="showFlag">
    <!--  出荷製品選択画面 -->
    <t-card>
      <div :style="{ height: basicHeight + 'px', 'padding-top': '10px' }">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          :label-width="$t('widgetSize.SEND.LABEL_WIDTH_100')"
        >
          <t-row
            type="flex"
            justify="center
          "
          >
            <!-- DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- 納品製品選択画面の検索条件と検索結果の変更 -->
            <!-- <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_SIX'))">
              <t-form-item
                :label="$t('resource.SEND.CUSTOMER')"
                class="marginBottom"
              >
                <t-select
                  v-model="searchConditionForm.searchCusCode"
                  class="commonDialog"
                  disabled
                >
                  <t-option
                    v-for="item in customerInfoList"
                    :key="item.cusCode"
                    :label="item.cusCode + ':' + item.cusAbbreviation"
                    :value="item.cusCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col> -->
            <!-- DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

            <!-- UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- <t-col :span="6" class="left"> -->
            <t-col :span="5" class="left">
              <!-- UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              <t-form-item
                :label="
                  $t('resource.SEND.ESTIMATED_NO') +
                  '/' +
                  $t('resource.SEND.CUS_ORDER_NO')
                "
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchQuoteNo"
                  class="commonDialog"
                  :clearable="true"
                  maxLength="20"
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 得意先納期 -->
            <t-col :span="8" class="left">
              <t-form-item
                :label="$t('resource.SEND.CUS_DELIVERY_DATE')"
                class="marginBottom"
              >
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 検索条件と検索チェックの変更 -->
                <!-- <t-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="～"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :editable="false"
                  style="
                    margin-top: 3px;
                    min-width: 20px;
                    width: 100%;
                    margin-left: -3px;
                  "
                  class="date_icon_center"
                  :clearable="false" -->
                <t-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="～"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :editable="false"
                  style="
                    margin-top: 3px;
                    min-width: 20px;
                    width: 100%;
                    margin-left: -3px;
                  "
                  class="date_icon_center"
                  :clearable="receRemainFlg"
                />
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
              </t-form-item>
            </t-col>

            <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- 検索条件の変更-->
            <t-col :span="4" class="left">
              <!-- 検索キー -->
              <t-form-item :label="$t('resource.sys.searchKey')">
                <t-input
                  clearable
                  v-model="searchConditionForm.searchWord"
                  maxLength="50"
                  style="width: 100%"
                >
                </t-input>
              </t-form-item>
            </t-col>
            <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

            <!-- ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓ -->
            <!-- 一式機能の追加 -->
            <t-col :span="2" class="right">
              <template>
                <t-checkbox
                  v-model="aobASetOnly"
                  :label="$t('resource.SEND.A_SET_ONLY')"
                  style="line-height: 3"
                />
              </template>
            </t-col>
            <!-- ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑ -->

            <t-col :span="2" class="right">
              <template>
                <!-- 入荷残有 -->

                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 検索条件と検索チェックの変更 -->
                <!-- <t-checkbox
                  v-model="receRemainFlg"
                  :label="$t('resource.SEND.REC_REMAIN_FLG')"
                  style="line-height: 3"
                /> -->
                <t-checkbox
                  v-model="receRemainFlg"
                  :label="$t('resource.SEND.REC_REMAIN_FLG')"
                  style="line-height: 3"
                  @change="handleChange"
                />
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
              </template>
            </t-col>
            <t-col :span="3" class="right">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <!-- UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓ -->
              <!-- <t-table
                ref="sendSelectTable"
                :data="sendSelectTable"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                :row-class-name="rowClassName"
                highlight-current-row
                border
                fit
              > -->
              <t-table
                ref="sendSelectTable"
                :data="sendSelectTable"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                highlight-current-row
                border
                fit
                row-key="id"
                default-expand-all
                @select-all="handleSelectAll"
              >
                <!-- ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑ -->
                <!-- UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑ -->
                <!-- 選択ボックス -->
                <t-table-column type="selection" class-name="cell_txt_center">
                  <!-- ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓ -->
                  <template slot-scope="scope">
                    <t-checkbox
                      v-if="scope.row.id < 10000"
                      v-model="scope.row.isSelected"
                      @change="handleSelectionChange(scope.row, $event)"
                    ></t-checkbox>
                  </template>
                  <!-- ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑ -->
                </t-table-column>
                <!-- テーブルの列 -->

                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 画面と文字サイズの調整 -->
                <!-- <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.prop === 'operate' ? 'right' : false"
                  :min-width="
                    column.prop === 'operate' ? '200px' : column.width
                  "
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->

                <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ -->
                <!-- 列固定：「注番」列 -->
                <!-- <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.prop === 'operate' ? 'right' : false"
                  :min-width="
                    column.prop === 'operate' ? '200px' : column.width
                  "
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="`${column.class} input_font_small`"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="index < 6"
                  :min-width="
                    column.prop === 'operate' ? '200px' : column.width
                  "
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="`${column.class} input_font_small`"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ -->

                  <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                  <!-- <template slot-scope="scope">
                    <div
                      v-if="scope.column.property == 'operate'"
                      style="width: 100%; min-width: 100px"
                    >
                      <t-steps :active="1" finish-status="success">
                        <t-step title="加工"></t-step>
                        <t-step title="处理1"></t-step>
                        <t-step title="处理2"></t-step>
                        <t-step title="处理3"></t-step>
                      </t-steps>
                    </div>
                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template> -->
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))
                "
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { initSendSearchList, searchSendSelectInfo } from "@/services/send";

import { t } from "@/locales";
import {
  formatDateToString,
  formatUndefinedToDate,
  getDialogContentHeight,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  STR_COLON,
  STR_EMPTY,
  STR_ONE,
  STR_TWO,
} from "@/utils/const";
import { flexColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      receRemainFlg: false, // 入荷残有

      //検索条件
      dateRange: [],
      searchConditionForm: {
        searchCusCode: "", // 得意先
        searchQuoteNo: "", // 見積No./注番
        searchStartDate: "", // 得意先納期(開始日)
        searchEndDate: "", // 得意先納期(終了日)
        receRemainExist: "", //入荷残有
        aobASetOnly: "", //一式のみ
        searchWord: "", //図番、品名、得意先担当者
      },

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      selectedRows: [], // 選択行のデータ
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      //日本入荷一覧選択情報
      sendSelectTable: [],

      // 得意先リスト
      customerInfoList: [],

      //注文製品選択情報(⇒日本入荷詳細画面（大連以外の工場）)
      selectedProcForm: [],

      maxheight: 260,
      //テーブルの列
      columns: [
        {
          // 見積No.
          prop: "sdQuoteNo",
          label: t("resource.SEND.ESTIMATED_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 緊急度の追加
        {
          prop: "aodUrgent",
          label: t("resource.ACCEPT_ORDER.AOD_URGENT"),
          width: t("widgetSize.tableCommon.width60"),
          align: "center",
        },
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        // 得意先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //prop: "aobCusDeliveryDate",
          prop: "aodCusDeliveryDate",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          label: t("resource.SEND.CUS_DELIVERY_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 得意先
        {
          prop: "sbCusCode",
          label: t("resource.SEND.CUSTOMER"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 End↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 検索条件の変更
        // 得意先担当者
        {
          prop: "aobCusUserCode",
          label: t("resource.ACCEPT_ORDER.CUS_USER_NAME"),
          // 画面と文字サイズの調整
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_THIRTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 注番
        {
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          prop: "aodCusOrderNo",
          label: t("resource.SEND.CUS_ORDER_NO"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 得意先納品先
        {
          prop: "aodCusDelvName",
          label: t("resource.ACCEPT_ORDER.DELI_ADDR"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // ミスミ関連区分
        {
          prop: "aodMisumiKbnStr",
          label: t("resource.ORDER.MSM_KBN"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

        // 品名
        {
          prop: "aodProdName",
          label: t("resource.SEND.PRODUCT_NAME"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.SEND.PRODUCT_DRAW_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 受注数
        {
          prop: "aodProdQuantity",
          label: t("resource.SEND.ACCEPT_ORDER_NUM"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.SEND.PRODUCT_UNIT"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SIXTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },
        // 運送中
        {
          prop: "transportingQty",
          label: t("resource.SEND.TRANSPORTING"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 日本入荷数
        {
          prop: "jrdReceQty",
          label: t("resource.SEND.OFFICER_RECEIVE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 出荷完了
        {
          prop: "sdProCompleteNum",
          label: t("resource.SEND.SEND_COMPLETE"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 未出荷
        {
          prop: "disSendNum",
          label: t("resource.SEND.DIS_DELIVERY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 出荷残
        {
          prop: "sdSendRemainQty",
          label: t("resource.SEND.SEND_REMAIN_QUANTITY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 受注日
        {
          prop: "aobAcceptDate",
          label: t("resource.SEND.ORDERED_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 仕入先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //   prop: "obDueDate",
          prop: "odDueDate",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          label: t("resource.SEND.SUPPLIER_DUE_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 列「注番」は「得意先担当者」列の後ろに移動
        // // 注番
        // {
        //   // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        //   // 納期、注番の変更(見積単位⇒製品単位に変更)
        //   //prop: "aobCusOrderNo",
        //   prop: "aodCusOrderNo",
        //   // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        //   label: t("resource.SEND.CUS_ORDER_NO"),
        //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        //   // 画面と文字サイズの調整
        //   // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
        //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

        // {
        //   prop: "operate",
        //   label: "進行状況",
        //   class: "cell_txt_left",
        // },
      ],

      //追加された「仕入先」列の番号
      newColumnNo: 0,

      //現在選択されているセル
      currentCell: null,

      data: null,

      showFlag: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT,
        DIALOG_LINE_HEIGHT,
        30
      ),
      //確定ボタンのheight
      bottomHeight: DIALOG_LINE_HEIGHT,

      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // 一式機能の追加
      aobASetOnly: false,
      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

      // UPD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 start↓
      //納品詳細画面の新規作成時に、一式データのチェックの追加
      countMap: {}, //一式データの納品可能数Map
      // UPD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 end↑
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    tableData: {
      Type: Object,
      default: null,
    },
    sbCusCode: {
      Type: Object,
      default: null,
    },
    //製品選択画面の検索条件
    selectedSearchForm: {
      Type: Object,
      default: null,
    },
    sbSendNo: {
      Type: Object,
      default: null,
    },

    // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
    //「一式データ」且 異常データを存在し場合:true
    exProdFlgASet: {
      Type: Boolean,
      default: false,
    },
    // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑
  },
  mounted() {
    // 初期化
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 列幅に自動調整
    // setColumnWidth(this.columns, this.sendSelectTable);
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      initSendSearchList()
        .then((res) => {
          // 得意先リスト
          this.customerInfoList = res.customerInfoList;
          //出荷製品選択画面の検索条件が空しない場合
          if (
            !!this.selectedSearchForm &&
            this.selectedSearchForm != STR_EMPTY
          ) {
            this.searchConditionForm = [];
            this.searchConditionForm = this.selectedSearchForm;
            if (this.searchConditionForm.searchStartDate == STR_EMPTY) {
              this.dateRange = [];
            } else {
              this.dateRange = [
                this.searchConditionForm.searchStartDate,
                this.searchConditionForm.searchEndDate,
              ];
            }
            // 入荷残有
            this.receRemainFlg = this.searchConditionForm.receRemainExist;
            // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
            // 一式機能の追加
            this.aobASetOnly = this.searchConditionForm.aobASetOnly; //一式のみ
            // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑
          } else {
            //日付初期化
            this.dateInit();
            // 入荷残有
            this.receRemainFlg = true;
            // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
            // 一式データの場合、一式を選択
            if (!!this.tableData && this.tableData.length > 0) {
              let aobASetExist = this.tableData.some(
                (item) => item.aobASet === STR_ONE
              );
              this.aobASetOnly = aobASetExist;
            }
            // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑`
          }

          this.searchClick();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
          this.showFlag = false;
        });
    },

    //日付初期化
    dateInit() {
      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      //var systemDate = new Date();
      // 日付初期値の設定
      // 検索条件と検索チェックの変更
      //this.dateRange = [systemDate, getNextMonthDate(systemDate)];
      this.dateRange = [];
      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      if (this.tableData) {
        //出荷明細テーブル得意先納期
        for (let index = 0; index < this.tableData.length; index++) {
          const element = this.tableData[index];

          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          // var aobCusDeliveryDate = formatUndefinedToDate(
          //   element.aobCusDeliveryDate
          // );

          // if (aobCusDeliveryDate > this.dateRange[1]) {
          //   this.dateRange[1] = aobCusDeliveryDate;
          // }
          // if (aobCusDeliveryDate < this.dateRange[0]) {
          //   this.dateRange[0] = aobCusDeliveryDate;
          // }

          var aodCusDeliveryDate = formatUndefinedToDate(
            element.aodCusDeliveryDate
          );

          if (aodCusDeliveryDate > this.dateRange[1]) {
            this.dateRange[1] = aodCusDeliveryDate;
          }
          if (aodCusDeliveryDate < this.dateRange[0]) {
            this.dateRange[0] = aodCusDeliveryDate;
          }
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        }
      }
    },

    // 検索
    searchClick() {
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 検索チェック
      if (!this.searchFormCheck()) {
        Modal.showWarning("", t("message.SEND.CUS_DELIVERY_DATE_INPUT_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      if (!this.showFlag) {
        this.showFlag = true;
      }
      // 検索条件の処理
      this.updateSearchForm();

      searchSendSelectInfo({
        sendSelectSearchForm: this.searchConditionForm,
        sbSendNo: this.sbSendNo,
      })
        .then((res) => {
          // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
          if (this.exProdFlgASet) {
            const tableQuoteNos = [
              ...new Set(this.tableData.map((item) => item.sdQuoteNo)),
            ];

            const tableQuoteNoSet = new Set(tableQuoteNos);

            this.sendSelectTable = res.sendDetailList.filter((item) =>
              tableQuoteNoSet.has(item.sdQuoteNo)
            );
          } else {
            // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑
            this.sendSelectTable = res.sendDetailList;
          }

          this.checkedProcess();

          // データ処理
          this.dataProcess();
          // ADD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 start↓
          //納品詳細画面の新規作成時に、一式データのチェックの追加
          //一式データの納品可能数
          this.countMap = res.sendDetailList.reduce((map, row) => {
            // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
            if (row["aobASet"] == 1) {
              // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑
              const quoteNo = row["sdQuoteNo"];
              map[quoteNo] = (map[quoteNo] || 0) + 1;
            }
            return map;
          }, {});
          // ADD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 end↑

          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 列幅に自動調整
          // setColumnWidth(this.columns, this.sendSelectTable);
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
          // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
          // 納品製品選択画面の一覧データ表示の最適化
          this.handleResize();
          // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
        });
    },

    // データ処理
    dataProcess() {
      this.sendSelectTable.map((item) => {
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)

        // // 得意先納期
        // if (item.aobCusDeliveryDate) {
        //   item.aobCusDeliveryDate = formatDateToString(item.aobCusDeliveryDate);
        // }
        // // 仕入先納期
        // if (item.obDueDate) {
        //   item.obDueDate = formatDateToString(item.obDueDate);
        // }
        // 得意先納期
        if (item.aodCusDeliveryDate) {
          item.aodCusDeliveryDate = formatDateToString(item.aodCusDeliveryDate);
        }
        // 仕入先納期
        if (item.odDueDate) {
          item.odDueDate = formatDateToString(item.odDueDate);
        }
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        // 受注日
        if (item.aobAcceptDate) {
          item.aobAcceptDate = formatDateToString(item.aobAcceptDate);
        }
        //未出荷：運送中+事務所入荷-出荷完了の合計
        item.disSendNum =
          item.transportingQty + item.jrdReceQty - item.sdProCompleteNum;

        //出荷残：受注数-出荷完了数の合計
        item.sdSendRemainQty = item.aodProdQuantity - item.sdProCompleteNum;
      });
    },

    //チェックボックスの選択処理
    checkedProcess() {
      if (!!this.tableData) {
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        this.selectedRows = [];
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        this.tableData.forEach((row) => {
          for (let index = 0; index < this.sendSelectTable.length; index++) {
            const element = this.sendSelectTable[index];

            //詳細画面選択のデータ選択チェックボックス
            if (
              row.sdQuoteNo == element.sdQuoteNo &&
              row.sdProdNo == element.sdProdNo &&
              row.sdOrderNo == element.sdOrderNo &&
              row.sdDetailNo == element.sdDetailNo &&
              // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
              row.id < 10000
              // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
            ) {
              this.$nextTick(() => {
                // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                // this.$refs.sendSelectTable.toggleRowSelection(
                //   this.sendSelectTable[index],
                //   true
                // );
                this.sendSelectTable[index].isSelected = true;
                this.selectedRows.push(row);
                // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
              });
            }
          }
        });
      }
    },

    //検索条件の調整
    updateSearchForm() {
      //検索条件:見積No.のスペースを削除
      this.searchConditionForm.searchQuoteNo =
        this.searchConditionForm.searchQuoteNo?.trim();
      //日付の設定
      if (this.dateRange.length > 0) {
        this.searchConditionForm.searchStartDate = formatDateToString(
          this.dateRange[0]
        );
        this.searchConditionForm.searchEndDate = formatDateToString(
          this.dateRange[1]
        );
      } else {
        this.searchConditionForm.searchStartDate = STR_EMPTY;
        this.searchConditionForm.searchEndDate = STR_EMPTY;
      }

      this.searchConditionForm.searchCusCode =
        this.sbCusCode.split(STR_COLON)[0];

      this.searchConditionForm.receRemainExist = this.receRemainFlg;

      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //図番、品名、得意先担当者
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord?.trim();
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // 一式機能の追加
      this.searchConditionForm.aobASetOnly = this.aobASetOnly; //一式のみ
      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑
    },

    //列幅に自動調整
    FlexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.sendSelectTable);
    },

    //确定ボタン
    confirmClick() {
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      // let data = this.$refs.sendSelectTable.selection;
      let data = this.selectedRows;
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      // 選択されたデータ処理
      if (!!data && data.length > 0) {
        // ADD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 start↓
        // 納品詳細画面の新規作成時に、一式データのチェックの追加
        if (this.checkASetDataCount(data)) {
          // ADD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 end↑

          this.selectedProcForm = data;
          let result = {
            selectedProcForm: this.selectedProcForm,
            searchConditionForm: this.searchConditionForm,
          };
          this.$emit("ok", result);
          // ADD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 start↓
          // 納品詳細画面の新規作成時に、一式データのチェックの追加
        } else {
          Modal.showWarning("", t("message.SEND.P08_W003"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
        }
        // ADD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 end↑
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    // ADD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 start↓
    // 納品詳細画面の新規作成時に、一式データのチェックの追加
    checkASetDataCount(dataList) {
      this.selectCountMap = dataList.reduce((map, row) => {
        const quoteNo = row["sdQuoteNo"];
        map[quoteNo] = (map[quoteNo] || 0) + 1;
        return map;
      }, {});
      return Object.keys(this.selectCountMap).every((quoteNo) => {
        // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
        if (!(quoteNo in this.countMap)) {
          return true;
          // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑
        }
        return this.selectCountMap[quoteNo] === this.countMap[quoteNo];
      });
    },
    // ADD 2026/02/06 Wjx 課題_260205顧客からの改善したい点への対応 end↑

    // 製品異常
    rowClassName({ row }) {
      if (row.sdProdExKbn === STR_TWO) {
        return "textColor";
      }
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT,
        DIALOG_LINE_HEIGHT,
        30
      );

      // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
      // 納品製品選択画面の一覧データ表示の最適化
      // 以前に設定したタイマーをクリアし、複数回実行を防ぐ
      clearTimeout(this.resizeTimer);
      // 50ミリ秒後に実行するタイマーを設定する
      this.resizeTimer = setTimeout(() => {
        const table = this.$refs.sendSelectTable;
        if (!table) return;

        const tableEl = table.$el;
        // テーブル本体のスクロール領域を取得する
        const bodyWrapper = tableEl?.querySelector(".el-table__body-wrapper");

        if (!bodyWrapper) return;

        // 左固定列を取得する
        const fixedLeft = tableEl?.querySelector(".el-table__fixed");

        //水平スクロールバーが存在するかどうか
        const hasWidthScrollbar =
          bodyWrapper.scrollWidth > bodyWrapper.clientWidth;

        if (!hasWidthScrollbar) {
          if (fixedLeft) fixedLeft.style.bottom = "0";
        } else {
          if (fixedLeft) fixedLeft.style.bottom = "";
        }
        table.doLayout();
      }, 50);
      // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 検索条件と検索チェックの変更
    handleChange(val) {
      //「入荷残有」が「チェックしない」から「チェックする」に変わると、得意先納期は自動的に空値になる
      if (val) {
        this.dateRange = [];
      }
    },
    searchFormCheck() {
      // 「入荷残有」が「チェックしない」場合、「得意先納期は空であってはならない
      if (!this.receRemainFlg && this.dateRange.length == 0) {
        return false;
      }
      return true;
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // 選択列かどうかを判断する
      const isSelectionColumn = columnIndex === 0;
      var msmColumnColorFlg =
        row.id >= 10000 &&
        row.dataKbn === STR_ONE &&
        ((column.property == "sdQuoteNo" && !row.sdQuoteNo) || // 見積No.
          isSelectionColumn ||
          (column.property == "aodUrgent" && !row.aodUrgent) || // 緊急度
          (column.property == "aodCusDeliveryDate" &&
            !row.aodCusDeliveryDate) || // 得意先納期
          (column.property == "sbCusCode" && !row.sbCusCode) || // 得意先
          (column.property == "aobCusUserCode" && !row.aobCusUserCode) || // 得意先担当者
          (column.property == "aodCusDelvName" && !row.aodCusDelvName) || // 得意先納品先
          (column.property == "aodProdQuantity" && !row.aodProdQuantity) || // 受注数
          (column.property == "aodProdUnit" && !row.aodProdUnit) || // 単位
          (column.property == "transportingQty" && !row.transportingQty) || // 運送中
          (column.property == "jrdReceQty" && !row.jrdReceQty) || // 日本入荷数
          (column.property == "sdProCompleteNum" && !row.sdProCompleteNum) || // 出荷完了
          (column.property == "disSendNum" && !row.disSendNum) || // 未出荷
          (column.property == "sdSendRemainQty" && !row.sdSendRemainQty) || // 出荷残
          (column.property == "aobAcceptDate" && !row.aobAcceptDate) || // 受注日
          (column.property == "odDueDate" && !row.odDueDate) || // 仕入先納期
          (column.property == "aodCusOrderNo" && !row.aodCusOrderNo)); // 注番

      //ミスミ_子データの場合
      if (msmColumnColorFlg) {
        return "bg-cell-editable_grey";
      }
    },

    handleSelectionChange(row, event) {
      // 選択状態を変更する
      row.isSelected = event;

      // selectedRowsに同期
      if (row.isSelected) {
        if (
          !this.selectedRows.some(
            (r) => r.sdQuoteNo === row.sdQuoteNo && r.sdProdNo === row.sdProdNo
          )
        ) {
          this.selectedRows.push(row);
        }
      } else {
        const index = this.selectedRows.findIndex(
          (r) => r.sdQuoteNo === row.sdQuoteNo && r.sdProdNo === row.sdProdNo
        );
        if (index !== -1) {
          this.selectedRows.splice(index, 1);
        }
      }
    },
    // すべて選択
    handleSelectAll(selection) {
      const selectableRows = this.sendSelectTable.filter(
        (row) => row.id < 10000
      );
      selectableRows.forEach((row) => {
        row.isSelected = selection.length > 0;
        this.handleSelectionChange(row, selection.length > 0);
      });
    },
    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
  },
};
</script>
<style scoped>
::v-deep .el-step__title {
  font-size: 11px;
  line-height: 19px;
}
/* ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓ */
::v-deep .el-table__expand-icon {
  display: none !important;
}
/* ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑ */

/* ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ */
/* DEL 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓ */
/* 納品製品選択画面の一覧データ表示の最適化 */
/* ::v-deep .el-table.table_common .el-table__fixed {
  height: auto !important;
  bottom: 16px;
} */
/* DEL 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑ */
/* ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ */
</style>
